export default __webpack_public_path__ + "media/images/gallery/38-7ebfb70d7e2d91a8a08241226b48dc36.png";